import { render } from "./Enviro.vue?vue&type=template&id=768981bc&scoped=true&ts=true"
import script from "./Enviro.vue?vue&type=script&lang=ts"
export * from "./Enviro.vue?vue&type=script&lang=ts"

import "./Enviro.vue?vue&type=style&index=0&id=768981bc&lang=scss&scoped=true"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768981bc"],['__file',"src/views/modules/insights/views/Enviro.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "768981bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('768981bc', __exports__)) {
    api.reload('768981bc', __exports__)
  }
  
  module.hot.accept("./Enviro.vue?vue&type=template&id=768981bc&scoped=true&ts=true", () => {
    api.rerender('768981bc', render)
  })

}


export default __exports__